import exitIntent from "exit-intent-quattro";

const exit_intent_cookie_name = "exit_intent";
const exit_intent_cookie_length_view_days = 7;
const exit_intent_cookie_length_submission_days = 90;
const exit_intent_init_delay_seconds = 10;

function setupDocumentForModals(html) {
	if (html.hasAttribute("data-modal-enabled") || html.hasAttribute("data-modal-status")) {
		return;
	}

	html.setAttribute("data-modal-enabled", "true");
	html.setAttribute("data-modal-status", "closed");
}

function getCookie(name) {
	var value = "; " + document.cookie;
	var parts = value.split("; " + name + "=");
	if (parts.length == 2) {
		return parts.pop().split(";").shift();
	}
	return null;
}

function changeElementToHeading(element, heading_level = 2) {
	if (null !== element) {
		const elementHTML = element.innerHTML;
		const elementAtts = element.attributes;
		const heading = document.createElement("h" + heading_level);

		// copy button attributes and content from element
		heading.innerHTML = elementHTML.trim();
		for (i = 0, len = elementAtts.length; i < len; i++) {
			var attr = elementAtts[i];
			if ("href" !== attr.name) {
				heading.setAttribute(attr.name, attr.value);
			}
		}

		return heading;
	}

	return element;
}

function changeElementToButton(element) {
	if (null !== element) {
		const elementHTML = element.innerHTML;
		const elementAtts = element.attributes;
		const button = document.createElement("button");

		// copy button attributes and content from element
		button.innerHTML = elementHTML.trim();
		for (i = 0, len = elementAtts.length; i < len; i++) {
			var attr = elementAtts[i];
			if ("href" !== attr.name) {
				button.setAttribute(attr.name, attr.value);
			}
		}

		return button;
	}

	return element;
}

function sendGAEvent(action, category, label) {
	var event = {
		hitType: "event",
		eventCategory: category,
		eventAction: action,
		eventLabel: label,
	};
	// console.table(event);

	if (typeof ga === "undefined") return;

	// ga("send", GAevent);
}

document.addEventListener("DOMContentLoaded", function () {
	document.querySelectorAll(".dialog-container").forEach(function (element, index) {
		setupDocumentForModals(document.documentElement);

		var dialogEl = element;
		// console.log(dialogEl);
		var dialogTrigger = document.querySelectorAll("[data-a11y-dialog-show='" + dialogEl.id + "']");
		// console.log(dialogTrigger);
		var dialogContent = dialogEl.querySelector(".dialog-content");
		// console.log(dialogContent);
		var dialogTitle = dialogEl.querySelector(".dialog-title");

		var dialogGALabel = dialogTitle.textContent;
		// console.log(dialogEl.id);
		if (dialogGALabel == "") {
			dialogGALabel = dialogEl.id + " – No heading found!";
		}

		var dialogExitIntentEnabled = false;
		if (
			index === 0 &&
			!document.documentElement.classList.contains("logged-in") &&
			!getCookie(exit_intent_cookie_name)
		) {
			dialogExitIntentEnabled = true;
		}

		if (typeof dialogTrigger != "object") {
			return;
		}

		dialogTrigger.forEach(function (trigger) {
			if (trigger.tagName === "SUMMARY") {
				var details = trigger.parentElement;
				details.setAttribute("open", "");
				details.addEventListener("toggle", function (event) {
					event.preventDefault();
				});

				var triggerButton = changeElementToButton(trigger);
				details.insertBefore(triggerButton, trigger.nextSibling);

				trigger.removeAttribute("class");
				trigger.setAttribute("hidden", "");
			}
		});

		dialogContent.setAttribute("role", "document");

		if (dialogTitle.textContent.trim() !== "") {
			var dialogHeading = changeElementToHeading(dialogTitle);
			dialogTitle.parentNode.replaceChild(dialogHeading, dialogTitle);
      
			if (dialogHeading.id !== "") {
				// console.log(dialogHeading.id);
				dialogEl.setAttribute("aria-labelledby", dialogHeading.id);
			}
		} else {
			console.warn("Heading text missing in Button Modal block. Block ID: " + dialogEl.id + ".");
			dialogTitle.remove();
		}

		dialogEl.removeAttribute("hidden");
		dialogEl.setAttribute("aria-hidden", "true");

		var dialog = new A11yDialog(dialogEl);

		dialog.on("show", function (element, event) {
			document.documentElement.setAttribute("data-modal-status", "open");

			sendGAEvent("Modal", "open", dialogGALabel);
		});
		dialog.on("hide", function (element, event) {
			document.documentElement.setAttribute("data-modal-status", "closed");

			sendGAEvent("Modal", "close", dialogGALabel);
		});

		if (dialogExitIntentEnabled) {
			// console.log(`exit-intent prepping for dialog ${index}`);
			setTimeout(function () {
				// console.log(`exit-intent active for dialog ${index}`);
				const removeExitIntent = exitIntent({
					edges: {
						top: true,
						right: false,
						bottom: false,
						left: false,
					},
					threshold: 20,
					maxDisplays: 1,
					eventThrottle: 200,
					onExitIntent: ({ side, position: { x, y } }) => {
						// console.log(`exit-intent triggered for dialog ${index} on ${side} side at position ${x}, ${y}`);
						document.cookie =
							exit_intent_cookie_name + "=1;max-age=" + 60 * 60 * 24 * exit_intent_cookie_length_view_days;
						dialog.show();
						sendGAEvent("Modal", "exit-intent", dialogGALabel);
					},
				});
			}, exit_intent_init_delay_seconds * 1000);
		}
	});
});

jQuery(document).on("gform_confirmation_loaded", function (event, form_id) {
	document.cookie = exit_intent_cookie_name + "=1;max-age=" + 60 * 60 * 24 * exit_intent_cookie_length_submission_days;
});
